import { IEntityId } from '../IEntityId';
import { BookSection } from './book-section';

export interface Book extends IEntityId<string> {
  versionId: number;
  armyId: number;
  armyName: string;
  armyLogo: string | null;
  updatedAt: number;
  sections: BookSection[];
  buildAt: number | null;
  buildUrl: string | null;
  buildStatus: BuildStatus;
}

export enum BuildStatus {
  NotBuilt = 0,
  Building = 1,
  Built = 2,
  Failed = 3,
}
